
import React from "react";

const HiringHeader: React.FC = () => {
  return (
    <div className="text-center mb-8">
      <h2 className="text-3xl font-bold mb-2">AI Staff Hiring</h2>
      <p className="text-muted-foreground">
        Choose and configure your new AI staff member
      </p>
    </div>
  );
};

export default HiringHeader;
